import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import Dropzone from "react-dropzone";
import { GET_SIGNED_URL } from "../../mutation/getSignedUrl";
import { hasuraClient, assetClient } from "../../apolloClient";
import { useMutation } from "@apollo/react-hooks";
import axios from "axios";
import { INSERT_REFERRAL_INVITES } from "../../mutation/insertReferralInvites";

const UploadCSV = (props) => {
  const [uploading, SetUploading] = useState(false);
  const [loadinMain, setLoadingMain] = useState(false);

  const [SignedURL] = useMutation(GET_SIGNED_URL, {
    client: assetClient,
  });

  const [InsertUser] = useMutation(INSERT_REFERRAL_INVITES, {
    client: hasuraClient,
  });

  const timestamp = Date.now().toString();

  const dataURLtoFile = (dataurl, fileType = "image/*") => {
    const byteString = atob(dataurl.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([arrayBuffer], { type: fileType });
  };

  const onDrop = async (files) => {
    if (files && files.length > 0) {
      props.setCurrentFile(files);
    }
  };

  const onDropCsv = () => {
    if (props.currentFile) {
      setLoadingMain(true);
      SetUploading(true);
      SignedURL({
        variables: {
          fileName: `referral-invite-csv/referral-invite-file/${timestamp}-${props.currentFile[0].name}`,
          value: "UPLOAD",
          type: "CSV",
        },
      }).then(async (response) => {
        const reader = new FileReader();
        reader.readAsDataURL(props.currentFile[0]);
        reader.onload = () => {
          const croppedFile = dataURLtoFile(
            reader.result,
            props.currentFile[0].type
          );
          const options = {
            method: "PUT",
            url: response.data.signedURL.url,
            headers: { "Content-Type": props.currentFile[0].type },
            data: croppedFile,
          };
          axios(options).then(async () => {
            try {
              await InsertUser({
                variables: {
                  file_name: `${timestamp}-${props.currentFile[0].name}`,
                  file_path: `referral-invite-csv/referral-invite-file/`,
                },
              })
                .then(() => {
                  SetUploading(false);
                  setLoadingMain(false);
                  props.setModalShow(false);
                  props.setIsInviteSuccess(true);
                })
                .catch(() => {
                  SetUploading(false);
                  setLoadingMain(false);
                });
            } catch (e) {}
          });
        };
      });
    }
  };

  return (
    <Modal
      className="add-user-popup"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="bulk-add-section">
          <div className="title">
            <h2>Upload CSV</h2>
          </div>
          <div className="bulk-add-section">
            <div className="file-upload">
              {/* <div className="dropzone">
                                <input type="file" />
                                <p>Drag and drop your .csv fild here<span>or <u>select a file</u> from your computer</span></p>
                            </div> */}

              <div className="App file-upload">
                {uploading === true ? (
                  <div>
                    <strong
                      style={{ fontSize: "18px" }}
                      className="error-message"
                    >
                      {" "}
                      Uploading . . .{" "}
                    </strong>
                  </div>
                ) : (
                  <Dropzone onDrop={onDrop} accept=".csv,text/csv">
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps({ className: "dropzone" })}>
                        <input {...getInputProps()} />
                        {props.currentFile === null ? (
                          <p>
                            Drag and drop your .csv file here
                            <span>
                              or <u>select a file</u> from your computer
                            </span>
                          </p>
                        ) : (
                          <p style={{ fontSize: "18px" }}>
                            File : {props.currentFile[0]?.name}
                          </p>
                        )}
                      </div>
                    )}
                  </Dropzone>
                )}
              </div>
            </div>
          </div>
          <p>
            {" "}
            Use the CSV import format below to import up to 150 users. We will
            automatically filter duplicate emails.
          </p>
          <ul className="doc-list">
            <li>
              <label>name,email,</label>
              <p>Maximilian Stenford, maxstenford@gmail.com </p>
            </li>
          </ul>
          <div className="submit-row">
            <div className="col">
              <button className="secondary-button" onClick={props.onHide}>
                Cancel
              </button>
            </div>
            <div className="col">
              <button
                className="primary-button"
                onClick={() => {
                  onDropCsv();
                }}
              >
                {!loadinMain ? (
                  "Send invites"
                ) : (
                  <Spinner
                    className="spinner"
                    animation="border"
                    role="status"
                    style={{ height: "20px", width: "20px" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default UploadCSV;
